export interface FeedbackGridEndpoints {
	fetchData: string
	fetchFilterOptions: string
	fetchRowActions: string
	updateCell: string
	export: string
	testBulkNotification: string
	sendBulkNotification: string
}

export interface FeedbackGridColumn {
	id: number
	aliasColumn: string
	normalizedColumn: string
	width: number
	specialQuestion: boolean
	filterType: number
	sortable: boolean
	order: number | null
	highlighted: boolean
	columnType: number
}

export interface SystemColumn {
	column: string
	translation: string
	show: boolean
	filter_identificator: string | null
	showFilter: boolean
	sortable: boolean
}

export interface FeedbackGridSettings {
	itemsPerPage: number
	widthUnit: number
	enlargedStripe: boolean
}

export interface FeedbackRow {
	id: number
	feedbackId: number
	data_unifier: number
	ta_processed_flag: number | null
	questionnaires: number
	feedbackLink?: string
	icon?: string
	note?: string
	annotated: boolean
	checked: boolean
	userName?: string
	statesColor?: string
	due_at?: string
	questionnaireName?: string
	translations?: Record<string, string>
	[key: string]: any
}

export interface GridData {
	data: FeedbackRow[]
	total: number
	hasMore: boolean
}

export interface FilterValue {
	[key: string]: string | string[] | boolean | null | { values: string[]; options: FilterOption[] }
}

export interface SortConfig {
	column: string
	order: 'ASC' | 'DESC'
}

export interface FeedbackGridProps {
	endpoints: FeedbackGridEndpoints
	initialData: GridData
	columns: FeedbackGridColumn[]
	systemColumns: SystemColumn[]
	settings: FeedbackGridSettings
	blockId: number
	isUserCategoryManager: boolean
	isAdmin: boolean
	initialFilters?: FilterValue
	translations: Record<string, string>
	defaultSort?: SortConfig | null
}

export interface FilterOption {
	value: string | number
	label: string
}

export enum FeedbackManagementFilterType {
	NONE = 0,
	MULTI_SELECT = 1,
	TEXT = 2,
}
